import PropTypes from 'prop-types';
import { Link } from '$components/basic/Link';
import Styled from './styled';

const getCurrency = (pathname) => {
  switch (pathname) {
    case 'car-park-index-2020-eur':
      return (
        <>
          *The Greater London boroughs collected a total of €830,048,036 in parking revenue in 2019, with a
          surplus of €518,143,770 after expenses. With an expected 61.67% reduction in revenue due to the
          COVID19 lockdown, the total surplus for 2020 is estimated to be €6,280,814. Details about the above
          calculations can be provided upon request.
        </>
      );
    case 'car-park-index-2020-usd':
      return (
        <>
          *The City of Chicago collected a total of $291,914,292 in parking revenue in 2019, with a surplus of
          $285,416,982 after expenses. With an expected 61.67% reduction in revenue due to the COVID19
          lockdown, the total surplus for 2020 is estimated to be $105,403,168.60. Details about the above
          calculations can be provided upon request.
        </>
      );
    default:
      return (
        <>
          *The Greater London boroughs collected a total of £727,960,000 in parking revenue in 2019, with a
          surplus of £454,417,000 after expenses. With an expected 61.67% reduction in revenue due to the
          COVID19 lockdown, the total surplus for 2020 is estimated to be £5,508,333. A shortfall of
          £448,908,667.
          <br />
          <br />
          The expected shortfall for parking income among metropolitan areas in the UK:
          <ul>
            <li>Manchester £18,021,000</li>
            <li>Edinburgh £22,647,371</li>
            <li>Birmingham £13,586,000</li>
            <li>Glasgow £14,931,536</li>
            <li>Liverpool £7,119,000</li>
            <li>Cardiff £7,691,000</li>
            <li>Leeds £6,488,000</li>
            <li>Sheffield £3,623,000</li>
            <li>Belfast £1,014,445</li>
          </ul>
        </>
      );
  }
};

const getEstimated = (pathname) => {
  switch (pathname) {
    case 'car-park-index-2020-eur':
      return '511 million euros';
    case 'car-park-index-2020-usd':
      return '180 million dollars';
    default:
      return '449 million pounds';
  }
};

export default function ContentSection({ ...props }) {
  const { pathname } = props;

  return (
    <Styled className="ContentSection">
      <p>
        Helping to make drivers&#39; <Link href="/mot">MOT</Link>,{' '}
        <Link href="/car-service">car service</Link> and <Link href="/car-diagnostic">repairs</Link> easier is
        what we&#39;re all about at Fixter. We began a study earlier this year to look into one of the most
        frustrating issues for drivers in the {pathname === 'car-park-index-2020-usd' ? 'US' : 'UK'} and
        around the world: high parking costs. the COVID-19 crisis unfolded, however, it became clear that
        practices like remote working and social distancing would mean far fewer cars on the road. While a
        marked reduction in pollution has been a huge boon for the environment, many city councils face a
        great loss of income from the reduction in parking revenue.{' '}
        <b>
          Major hubs like {pathname === 'car-park-index-2020-usd' ? 'Chicago' : 'London'} who rely on this
          revenue to fund public services stand to lose an estimated {getEstimated(pathname)} due to the
          pandemic.*
        </b>
      </p>
      <p>
        As restrictions ease and movements increase, cities and drivers everywhere now have an opportunity
        reassess how things have been done in the past. With many countries already having considered car bans
        in major city centres before the pandemic, and alternative means of transport like cycling becoming
        increasingly popular, city councils around the world will need to re-think their parking cost
        strategies. While these developments are a positive trend for commuters, it is reasonable to believe
        that parking costs will remain high for the foreseeable future. With this in mind, we decided to
        release our <b>2020 Parking Price Index</b> which{' '}
        <b>reveals the differences in the cost of parking around the world.</b>
      </p>
      <p>
        We began the index by first considering all of the major locations from our first-hand experience that
        charge the highest parking prices, as well as those which we regularly drive to. The sites which first
        came to mind are the places where you drop loved ones off or pick them up, namely airports. Next, we
        considered shopping districts looking at both car parks and street parking, as well as sporting
        stadiums.
      </p>
      <p>
        Finally, we found the parking cost at each location&#39;s city hall, as they are generally located the
        centre of town, where parking costs can be at a premium. Recording the average price per hour to park
        in each of these spots for 65 locations, we were then able to see which cities pay the most and least
        for parking, as well as how high or low the price is compared to the global median. The final index is
        ranked by the average deviation of the price to park in all of these locations across a city, from
        highest to lowest.
      </p>
      <p>
        <b>
          Below you can find the full results. Each column is filterable from highest to lowest. The complete
          methodology can be found at the bottom of the page.
        </b>
      </p>
      <p>{getCurrency(pathname)}</p>
    </Styled>
  );
}

ContentSection.propTypes = {
  pathname: PropTypes.string,
};

ContentSection.defaultProps = {
  pathname: '',
};
